import React from "react";
import { useResponsive } from "../../../UI/ResponsiveContext";
import { t } from "i18next";
import { AppColumn, AppRow } from "../../../UI/Layouts";
import useTheme from "../../../../hooks/useTheme";
import { Icon } from "semantic-ui-react";
import AppText from "../../../UI/Texts/AppTexts";
import { SizedBox } from "../../../UI/Sizes";
import LearnMoreRegisterButton from "./LearnMoreRegisterButton";
import { AppLinkedText } from "../../../UI/CustomButtons";
import { LOGIN_PATH } from "../../../../utils/Constants/Paths";

const LearnMoreAboutWorkplace = ({ openModal, jobData }) => {
  const theme = useTheme();
  const { isMobile } = useResponsive();

  const benefits = [
    t('learn_more_benefit_1'),
    t('learn_more_benefit_2'),
    t('learn_more_benefit_4'),
  ]


  return (
    <AppColumn crossAxisAlignment={"start"}>
      <div
        style={{
          width: "100%",
          borderRadius: theme.radius.default,

        }}
      >
        <AppColumn crossAxisAlignment={"start"}>
          <AppText.BodyText> {t("learn_more_description")}</AppText.BodyText>
          <SizedBox height={theme.spacing.elementPadding} />
          <div>
            {benefits.map((benefit) => (<AppRow crossAxisAlignment={isMobile ? 'start' : 'center'} style={{
              marginBottom: theme.spacing.elementPadding,
            }}>
              <Icon name="star" size="small" style={{
                color: theme.primaryColor,
                paddingTop: isMobile && '0.25rem',
              }} />
              <SizedBox width={theme.spacing.elementPaddingSmall} />
              <AppText.BodyText >{benefit}</AppText.BodyText>
            </AppRow>))}
          </div>
          <SizedBox height={theme.spacing.elementPadding} />
          <AppText.BodyText center>{t('learn_more_footer')}</AppText.BodyText>

          <SizedBox height={theme.spacing.contentElementPadding} />
          <AppColumn crossAxisAlignment={isMobile && 'center'} style={{
            width: isMobile && "100%",
          }}>
            <LearnMoreRegisterButton openModal={openModal} jobData={jobData}/>
            <SizedBox height={theme.spacing.contentElementPadding} />
            <AppRow mainAxisAlignment={isMobile && "center"}>
              <AppLinkedText
                text={t('login')}
                href={LOGIN_PATH}
                underline
              />
            </AppRow>
          </AppColumn>
          <SizedBox height={theme.spacing.elementPadding} />
        </AppColumn>
        <SizedBox height={theme.spacing.contentPadding} />
      </div >
    </AppColumn >
  )
}




export default LearnMoreAboutWorkplace;